import StyledSelect2 from "./StyledSelect2";  

export default StyledSelect2;
